import React, { useContext } from "react";
import { digitsThree } from "../../../../utils/price";
import { context } from "../../../../context/context";
import { convertDate } from "../../../../utils/convertDate";
import { PiArrowLeftFill } from "react-icons/pi";

function LoanDetailsCard({ data }) {
  console.log(data);
  const { utils } = useContext(context);
  return (
    <div className="shadow p-3 rounded-md">
      <h4 className="mt-4">جزئیات تغییر</h4>
      <div className="flex flex-col gap-3 text-gray-500 py-4 border-b-2">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <p className="w-full text-center sm:text-right flex gap-2 items-center">
            کد ملی تغییر دهنده : {data?.creatorUserNationalId || "-"}
          </p>
          <p className="w-full text-center sm:text-right flex gap-2 items-center">
            شخص : {data?.type == "guarantor" ? "ضامن" : "وام گیرنده"}
          </p>
          <p className="w-full text-center sm:text-right flex gap-2 items-center">
            تاریخ تغییر : {data?.createdAt ? convertDate(data?.createdAt) : "-"}
          </p>
        </div>
      </div>
      {(data?.nationalId ||
        data?.name ||
        data?.mobile ||
        data?.bankAccountId ||
        data?.jobDescription ||
        data?.job) && (
        <>
          <h4 className="mt-4">مشخصات</h4>
          <div className="flex flex-col gap-3 text-gray-500 py-4">
            <div className="grid md:grid-cols-2 gap-4">
              {data?.name && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  نام : {data?.name?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.name?.next || "-"}
                </p>
              )}

              {data?.nationalId && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  کد ملی : {data?.nationalId?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.nationalId?.next || "-"}
                </p>
              )}
              {data?.mobile && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  موبایل : {data?.mobile?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.mobile?.next || "-"}
                </p>
              )}
              {data?.bankAccountId && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  شماره حساب : {data?.bankAccountId?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.bankAccountId?.next || "-"}
                </p>
              )}
              {data?.job && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  شغل : {data?.job?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.job?.next || "-"}
                </p>
              )}
              {data?.jobDescription && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  توضیحات شغلی : {data?.jobDescription?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.jobDescription?.next || "-"}
                </p>
              )}
            </div>
          </div>
        </>
      )}

      {(data?.amount ||
        data?.remainingGuaranteeLimit ||
        data?.promissoryNote ||
        data?.installmentAmount ||
        data?.creditType) && (
        <>
          <h4 className="mt-4">اعتبار سنجی</h4>
          <div className="flex flex-col gap-3 text-gray-500 py-4">
            <div className="grid md:grid-cols-2 gap-4">
              {data?.amount && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  مبلغ وام : {data?.amount?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.amount?.next || "-"}
                </p>
              )}
              {data?.remainingGuaranteeLimit && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  مانده سقف ضمانت : {data?.remainingGuaranteeLimit?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.remainingGuaranteeLimit?.next || "-"}
                </p>
              )}
              {data?.remainingGuarantee && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  سقف ضمانت : {data?.remainingGuarantee?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.remainingGuarantee?.next || "-"}
                </p>
              )}
              {data?.promissoryNote && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  مبلغ سفته : {data?.promissoryNote?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.promissoryNote?.next || "-"}
                </p>
              )}
              {data?.installmentAmount && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  مبلغ قسط : {data?.installmentAmount?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.installmentAmount?.next || "-"}
                </p>
              )}
              {data?.creditType && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  وضعیت اعتبار سنجی :{" "}
                  {utils?.CREDIT_TYPE?.[data?.creditType?.prev]?.name || "-"}
                  <PiArrowLeftFill />
                  {utils?.CREDIT_TYPE?.[data?.creditType?.next]?.name || "-"}
                </p>
              )}
            </div>
          </div>
        </>
      )}

      {(data?.frontNationalIdImage ||
        data?.backNationalIdImage ||
        data?.birthCertificateImage ||
        data?.salarySlipImage ||
        data?.threeMonthBankStatementImage) && (
        <>
          <h4 className="mt-4">مدارک</h4>
          <div className="flex flex-col gap-3 text-gray-500 py-4">
            <div className="grid md:grid-cols-2 gap-4">
              {data?.frontNationalIdImage && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  تصویر جلو کارت ملی : {data?.frontNationalIdImage?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.frontNationalIdImage?.next || "-"}
                </p>
              )}
              {data?.backNationalIdImage && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  تصویر پشت کارت ملی : {data?.backNationalIdImage?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.backNationalIdImage?.next || "-"}
                </p>
              )}
              {data?.birthCertificateImage && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  تصویر شناسنامه : {data?.birthCertificateImage?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.birthCertificateImage?.next || "-"}
                </p>
              )}
              {data?.salarySlipImage && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  فیش حقوقی : {data?.salarySlipImage?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.salarySlipImage?.next || "-"}
                </p>
              )}
              {data?.threeMonthBankStatementImage && (
                <p className="w-full text-center sm:text-right flex gap-2 items-center">
                  پرینت حساب 3 ماهه :{" "}
                  {data?.threeMonthBankStatementImage?.prev || "-"}
                  <PiArrowLeftFill />
                  {data?.threeMonthBankStatementImage?.next || "-"}
                </p>
              )}
            </div>
          </div>
        </>
      )}
      {data?.message ? (
        <>
          <h4 className="mt-4">
            ضامن - {data?.name || ""} - {data?.nationalId}
          </h4>
          <div className="flex flex-col gap-3 text-gray-500 py-4">
            <p>{data?.message || ""}</p>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default LoanDetailsCard;
